"use client";

import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useState } from "react";
const SidePanelContext = /*#__PURE__*/createContext(undefined);
export const SidePanelProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const togglePanel = () => {
    setIsOpen(prev => !prev);
  };
  return __jsx(SidePanelContext.Provider, {
    value: {
      isOpen,
      togglePanel
    }
  }, children);
};
export const useSideOverPanel = () => {
  const context = useContext(SidePanelContext);
  if (context === undefined) {
    throw new Error('useSideOverPanel must be used within a SidePanelProvider');
  }
  return context;
};